import { render } from "./MemoryUsage.html?vue&type=template&id=6d841d12&ts=true"
import script from "./MemoryUsage.ts?vue&type=script&lang=ts"
export * from "./MemoryUsage.ts?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__